import type { ReactNode } from 'react'
import type { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
import {
    FormControl,
    type FormControlLabelVisibility,
} from '@/React/Shared/Component/Forms/FormControl'

interface ApiFormControlProps {
    children: ReactNode
    inputName: RequestBodyKeyEnum
    apiFormResponse: ApiFormResponseType | null
    label?: string
    labelVisibility?: FormControlLabelVisibility
    required?: boolean
    className?: string
    helperText?: ReactNode
}

export function ApiFormControl({
    children,
    inputName,
    apiFormResponse,
    label,
    labelVisibility = 'visible',
    required = false,
    className = '',
    helperText,
}: ApiFormControlProps) {
    const error = apiFormResponse?.getValidationError(inputName) ?? null

    return (
        <FormControl.Container className={className}>
            <FormControl.Label
                id={`${inputName}-label`}
                htmlFor={inputName}
                required={required}
                visibility={labelVisibility}
            >
                {label}
            </FormControl.Label>

            <div>{children}</div>

            {error ? <FormControl.Error error={error} /> : null}

            {helperText ? (
                <FormControl.HelperText id={`${inputName}-helper`}>
                    {helperText}
                </FormControl.HelperText>
            ) : null}
        </FormControl.Container>
    )
}
